import { Tooltip } from 'antd';
import React from 'react'
import { MetricCard } from '../../atoms';
import moment from 'moment'
import { Bargraph, CommentSection, DoughnutGraphHRA, RatingCard } from '../../organisms'
import {calender_img, healthCheckMale, family_img, rupee, info_img} from '../../../../assets/images'
import { PreferredPartner } from '../../molecules';
import { UserAlert } from '../../atoms/alerts';
import { commaingNumber } from '../../../../utils';

const SpendingAccount = ({metricObj, ratingObj, utilizationObj,loading}) => {
  const { start_date, end_date, employee_per_count,
         utilized_employees_count,utilized_employees_amount, 
         utilized_dependent_count, utilized_dependent_amount, 
         total_customers_amount,  utilized_amount_utilization,  
         avg_utilization_amount, donutData = [], partners = [], dependent_level = true } = metricObj; //done 
  const { ratingsPercent, totalratings, averagerating, commentSectionData } = ratingObj;//done
  const { barlabels, bardata = [], barBgColors, xAxesLabel } = utilizationObj;//need
  let maxLength = 0, stepLength = 0, max = 0 
  max  = Math.max(...bardata)
  const getRange = (max) => {
    if(max === 0) return 
    if(max < 25) {
      maxLength = 25 
      stepLength = 5
    }
    else if(max >= 25 && max < 100){
      maxLength = 100 
      stepLength = 20
    }
    else{
      let maxNumber = max + (100 - max % 5)
      stepLength = Math.round(maxNumber / 5)
      maxLength = stepLength * 5
    }
  }
  getRange(max)
  return (
    <div>
      <p className='text-gray-700 text-base font-semibold mt-8 mb-3 leading-none'>Sponsored Health Checks</p>
      <div className='flex flex-row justify-between'> 
         <MetricCard
            title='Start date & end date'
            loading={loading}
            loaderHeight={120}
            svgsrc={calender_img} 
            titleClasses='text-gray-500 leading-4'
            metricClasses='mt-7  xl:mt-6'
            classes={dependent_level ? 'w-1/3 mr-4' : 'w-1/2 mr-4'}
            metricValue={<span className='font-semibold text-3xl text-gray-700'>{(`${start_date} - ${end_date}`) || 0}</span>}
         />
          <MetricCard
            title='No. of employees who availed benefits'
            svgsrc={healthCheckMale}
            loading={loading} 
            loaderHeight={120}
            classes={dependent_level ? 'w-1/3 mr-4' : 'w-1/2'}
            titleClasses='text-gray-500 leading-4 block'
            metricValue={<span className=' font-semibold  text-3xl text-gray-700'>{utilized_employees_count}</span>}
         />
         { dependent_level &&
            <MetricCard
              title='No. of family members availed benefits'
              svgsrc={family_img} 
              loading={loading}
              loaderHeight={120}
              classes='w-1/3'
              titleClasses='text-gray-500 leading-4 block'
              metricValue={<span className=' font-semibold  text-3xl text-gray-700'>{utilized_dependent_count}</span>}
            />   
         }      
      </div>  
      <div className='flex flex-row justify-between mt-4'>
         <MetricCard
            title='Benefits / employee'
            loading={loading}
            loaderHeight={120}
            svgsrc={rupee} 
            titleClasses='text-gray-500 leading-4'
            classes={dependent_level ? 'w-1/3 mr-4' : 'w-1/2 mr-4'}
            metricValue={<span className=' font-semibold  text-3xl text-gray-700'>{ '₹ '+ (!employee_per_count ? 0 : employee_per_count.toLocaleString('en-IN') ) }</span>}
         />
          <MetricCard
            title='Total amount utilized by employees'
            svgsrc={rupee} 
            loading={loading}
            loaderHeight={120}
            titleClasses='text-gray-500 leading-4 block'
            classes={dependent_level ? 'w-1/3 mr-4' : 'w-1/2'}
            metricValue={<span className=' font-semibold  text-3xl text-gray-700'>{'₹ '+ (!utilized_employees_amount ? 0 : utilized_employees_amount.toLocaleString('en-IN') ) }</span>}
         />
         {  dependent_level && 
            <MetricCard
              title='Total amount utilized by family members'
              svgsrc={rupee} 
              loaderHeight={120}
              loading={loading}
              classes='w-1/3'
              titleClasses='text-gray-500 leading-4 block'
              metricClasses='mt-5 xl:mt-5 2xl:mt-6'
              metricValue={<span className='font-semibold text-3xl text-gray-700'>{'₹ '+ (!utilized_dependent_amount ? 0 : utilized_dependent_amount.toLocaleString('en-IN') )}</span>}
            />  
         }       
      </div>
        <div className='flex flex-row mt-8'>
          <div className='flex flex-col w-2/4 mr-4'>
          <p className='text-gray-700 text-base font-semibold mb-3 leading-none'>Average percentage utilization
          <Tooltip
              placement='top'
              title='Total amount utilized / Total amount allocated'
            >
              <img src={info_img} className='h-4 w-4 ml-2 inline text-gray-100' alt='info_icon' />
            </Tooltip>
          </p>  
          { !loading && donutData.length === 0  ? 
            <div className='bg-white w-full  border rounded-md h-full'  >
             <UserAlert para='Data is not available' paraClasses='font-semibold text-gray-600' imgClasses='h-5 w-5' classes=' p-4 m-4'/>
           </div>
           : 
          <DoughnutGraphHRA
            loaderHeight={265}
            graphData ={donutData}
            loading={loading}
            hraCompleted={commaingNumber(utilized_amount_utilization)}
            totalCustomers={commaingNumber(total_customers_amount)}
            circleTitle ='Average utilization'
            title='Average percentage utilization'
            classes='h-full justify-center'
          />
          }  
          </div>
          <div className='flex flex-col w-2/4 '>
          <p className='text-gray-700 text-base font-semibold mb-3 leading-none'>Average amount utilized per employee
          <Tooltip
              placement='top'
              color='pink'
              key='pink'
              title='Total amount utilized across the employees / total eligible employees'
            >
              <img src={info_img} className='h-4 w-4 ml-2 inline text-gray-100' alt='info_icon' />
            </Tooltip>
          </p>
          <div style={{height : '92px'}}>
          <MetricCard
              title='Average amount utilized per employee'
              loading={loading}
              loaderHeight={92}
              titleClasses='text-gray-500 leading-4'
              subTitle={'₹ ' + ( avg_utilization_amount || 0) }
              subTitleClasses='text-2xl mb-4 mt-1.5 font-semibold text-gray-700'
              classes='h-full w-full'
              svgsrc={rupee} 
          />
          </div>
          <p className='text-gray-700 text-base font-semibold mt-4 mb-3 leading-none'>
              Top preferred partners by your employees
            </p>
            { partners.length === 0 && !loading  ?
                <div className='bg-white w-full  border rounded-md '  style={{height : '145px'}}  >
                  <UserAlert para='Data is not available' paraClasses='font-semibold text-gray-600' imgClasses='h-5 w-5' classes=' p-4 m-4'/>
                </div>
               :
               <div style={{height : '136px'}}>
                  <PreferredPartner
                    loaderHeight={129} 
                    loading={loading}
                    list={partners}  
                    classes='h-full' 
                  />
              </div>
            }
          </div>
        </div>
      <div className='text-base font-semibold mt-8 text-gray-700 leading-none'>Month on Month total amount utilization</div>
      <div
        className={'mt-6 rounded-md bg-white'}
      >
        {bardata && bardata.length === 0 && !loading && (
          <UserAlert
            para={`${xAxesLabel} data is not available`}
            paraClasses=' font-semibold text-gray-600'
            imgClasses=' h-5 w-5'
            classes='p-4'
          />
        )}
        <Bargraph
          id='utilizationBarGraph'
          loaderHeight={300}
          loading={loading}
          data={bardata}
          labels={barlabels}
          backgroundColor={barBgColors}
          height='300px'
          type='bar'
          ticks={{
            min: 0,
            max: (maxLength),
            stepSize: (stepLength),
          }}
          dataPoints='in-thousands'
          barTag='in-thousands'
          xAxesLabel={xAxesLabel || 'Months'}
          yAxesLabel='Amount utilization'
        />
      </div>
      <div className='flex flex-row mt-8'>
        <div className='flex flex-col w-2/4 pr-4'>
          <div className='text-base font-semibold text-gray-700 leading-none mb-1'>Ratings</div>
          <div className='text-sm mb-3 text-gray-600'>
          These ratings are captured after utilizing spending account
          </div>
          <RatingCard
            loading={loading}
            loaderHeight={200}
            rating={averagerating}
            number_of_ratings={totalratings}
            five_star_rating={ratingsPercent && ratingsPercent[4]}
            four_star_rating={ratingsPercent && ratingsPercent[3]}
            three_star_rating={ratingsPercent && ratingsPercent[2]}
            two_star_rating={ratingsPercent && ratingsPercent[1]}
            one_star_rating={ratingsPercent && ratingsPercent[0]}
            classes='h-full'
          />
        </div>
        <div className='w-2/4 flex flex-col'>
          <div className='text-base font-semibold text-gray-700 leading-none mb-1'>Top Comments</div>
          <div className='text-sm mb-3 text-gray-600'>
          These reviews are captured after utilizing spending account
          </div>
          <CommentSection 
          loaderHeight={200}
          loading={loading}
          points={commentSectionData || []} 
          classes='h-full' />
        </div>
      </div>
    </div>
  )
}

export default SpendingAccount